import { render } from "./ContactUs.vue?vue&type=template&id=58504956"
const script = {}

import exportComponent from "C:\\Work2022\\300_NEVTER\\500_DEVEL\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__